import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { ProfileCommon } from './profile.common';
import { PageBaseFull } from '../../../../core/page-base.full';
import { UserData } from '../../../../providers/user-data'; 
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';
import { AccountCommon } from '../account/account.common';
import { LoginPage } from '../login/login';
import { Helpers } from '../../../../providers/helpers';

@Component({
	selector: 'page-profile-full',
	templateUrl: 'profile.full.html'
})

export class ProfilePageFull extends PageBaseFull{
	public currentUser: any;
	public submitted = false;
	public formMsg: any;
	public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	constructor(
    	public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,		
		public common: ProfileCommon,
		public nav: NavController,
    	public userData: UserData,
    	public settings: AppSettings,
    	public pageRef: PageRef,
    	public accountCommon: AccountCommon,
		public helpers: Helpers
		//public recipeData: RecipeData,
    ) {	
		 super(settings, events, nav, userData);
		 console.log("Loading Profile Full");
    }
	nameRegEx : RegExp = /^(a-z|A-Z|0-9)*[^!#$%^&*()'"\/\\;:@=+,?\[\]\/]*$/;
	addressRegx : RegExp = /^(a-z|A-Z|0-9)*[^!$%^&*()'"\/\\;:@=+,?\[\]]*$/;
	zipcodeRegx : RegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

	ionViewDidEnter() {
		this.app.setTitle('Account > Profile');
	}

	ngAfterViewInit() {
		//this.common.commonMethod();
		let self = this;
		self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
			if(isLoggedIn){
				self.accountCommon.loadUserData(this.nav);
			}
			else{
				self.nav.setRoot(LoginPage);
			}
		});
	}

	public saveProfile(form){
		var self = this
		this.currentUser.displayName = this.currentUser.firstName + " " + this.currentUser.lastName;
		this.currentUser;
		if(this.currentUser.uid !== null || this.currentUser.uid !== ''){
	        self.common.updateProfile(this.currentUser, this.currentUser.uid).subscribe(updated =>{
				if(updated.result){
					self.helpers.toast("Update successfully!");
					self.userData.setUser(this.currentUser);
				}else{
					self.helpers.toast(updated.error);
				}
	        	
	        });
    	}
	}

	public cancel(){
		this.nav.setRoot(this.pageRef.get('home'));
	}
	
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/profile/profile.full.ts